<template>
  <div class="d-flex justify-content-center">
    <b-row class="mt-3 col-12 col-lg-12 col-xl-12">
      <b-col class="col-12 text-center">
        <p>
          {{$t('creator.attachmentsText')}}
        </p>

        <b-button-group class="w-100 mt-1 mb-2">
          <b-button 
            @click="tabs_options = 0" 
            :class="{'active': tabs_options === 0}" 
            class="button-tabs-options mr-1" 
            variant="button-tabs-options"
            
          >
            {{ $t('creator.files') }}
            <span v-if="files.length > 0">({{ files.length }})</span>
          </b-button>
          <b-button 
            @click="tabs_options = 1" 
            :class="{'active': tabs_options === 1}" 
            class="button-tabs-options" 
            variant="button-tabs-options"
          >
            Links 
            <span v-if="links.length > 0 ">({{ links.length }})</span>
          </b-button>
        </b-button-group>

        <div v-if="tabs_options === 0">
          <div>
            <b-form-file 
              v-model="file" 
              accept=".jpeg, .jpg, .png, .mp4, .mov, .pdf, .docx, .xlsx, .pptx, .csv, .txt, .rtf"
              browse-text="Buscar" 
              class="my-2" 
              @input="hasChangeFiles"
              :placeholder="$t('creator.chooseFileFiles')"
            >
            </b-form-file>
          </div>

          <attachment-file-item
            v-for="(file, index) in files"
            :key="index"
            :file="file"
            :asset-types="$t('creator.asset_type')"
            :update-avatar-key="update_avatar"
            :verify-asset="verifyAsset"
            :img-orvid="imgOrvid"
            :txt-ext="txtExt"
            :is-image="isImage"
            :error-load="errorLoad"
            @delete="deleteFromList"
            @set-asset-type="({ file, assetType }) => addAssetType(file, assetType)"
          />
        </div>

        <div v-else>
          <step-attachment-links 
            :links="links"
            @delete_link="deleteFromListLink"
            @update_button_save="update_button_save = !update_button_save"
          ></step-attachment-links>
        </div>
        <b-col class="col-12 d-flex justify-content-center flex-wrap">
          <b-button 
            variant="blue-button-next-step" 
            class="blue-button-next-step my-2" 
            @click.once="save()"
            :disabled="!disabledButton() || loading_service"
            :key="update_button_save"
          > 
            <div v-if="loading_service">
              <b-spinner class="spinner-waiting-service"></b-spinner>
              {{ $t('creator.upLoading') }}
            </div>
            <div v-else-if="!has_slug">
              {{ $t('creator.saveStep') }}
            </div>
            <div v-else>
              {{ $t('creator.savePreview') }}
            </div>
          </b-button>
          <small class="mt-2 w-100 text-center text-muted">{{ $t('creator.attachOptional') }}</small>

        </b-col>
      </b-col>
    </b-row>
    <modal-brandme
      size="md"
      v-if="modal_confirmation"
      :show_modal="modal_confirmation"
      @hidden="closeModalConfirmation"
    >
      <template #title>
        {{ $t('creator.confirmAction') }}
      </template>

      <template #body>
        <div>
          
          {{ delete_type === 'file'
            ? $t('creator.sureDeleteFile')
            : $t('creator.sureDeleteLink')
          }}
        </div>

        <div
          v-if="delete_type === 'file' && item_to_delete"
          class="mt-3 p-2 border rounded bg-light d-flex flex-column align-items-start"
        >

          <div
            v-if="isImage(item_to_delete.preview.preview)"
            class="d-flex align-items-center mb-2"
          >
            <b-avatar
              :src="item_to_delete.preview.preview"
              square
              class="avatar-preview-sample mr-2"
            />
            <span>{{ $t('creator.upFile') }}</span>
          </div>
          <div
            v-else-if="isVideo(item_to_delete.preview.preview)"
            class="d-flex align-items-center mb-2"
          >
            <video
              :src="verifyAsset(item_to_delete.preview.preview)"
              class="avatar-preview-sample mr-2"
            />
            <span>{{ $t('creator.upFile') }}</span>
          </div>

          <div
            v-else
            class="d-flex align-items-center mb-2"
          >
            <b-icon icon="file-earmark" class="mr-2"/>
            <span>{{ $t('creator.upFile') }}</span>
          </div>

        </div>

        <div
          v-if="delete_type === 'link' && item_to_delete"
          class="mt-3 p-2 border rounded bg-light d-flex flex-column align-items-start"
        >

          <small class="text-muted">
           Link: {{ item_to_delete.link }}
          </small>
        </div>

        <div class="d-flex justify-content-end mt-3">
          <b-button
            variant="outline-secondary mr-2"
            @click="closeModalConfirmation"
          >
           {{ $t('creator.cancel') }}
          </b-button>

          <b-button
            variant="danger"
            @click="confirmDelete"
          >
            {{ $t('creator.delete') }}
          </b-button>
        </div>
      </template>
    </modal-brandme>
  </div>
</template>

<script>
import {
  BIcon,
  BAvatar,
  BRow,
  BCol,
  BButton,
  BFormFile,
  BSpinner,
  BButtonGroup,
} from 'bootstrap-vue';
import { getThumbnails } from 'video-metadata-thumbnails';
import { getUniqueIndex } from '@/libs/utils/others'
import { getAssetUrl, urlStateExpression, verifyAsset} from '@/libs/utils/urls'
import { shortText, isVideo } from '@/libs/utils/formats';
import { deleteFile, createTempFile, getImageUpdatedfile, deleteLink, attatchFiles, updateFiles, attatchLinks, updateLinks, updateCastingCall } from '@/services/casting_calls';
import utils from '@/libs/utils';

export default {
  name: 'stepAttachmentFiles',
  components: {
    BIcon,
    BAvatar,
    BRow,
    BCol,
    BButton,
    BFormFile,
    BSpinner,
    BButtonGroup,
    AttachmentFileItem: () => import('./components/AttachmentFileItem.vue'),
    stepAttachmentLinks: () => import('./components/stepAttachmentLinks.vue'),
    modalBrandme: () => import('@/views/components/modal/ModalBrandme.vue'),
  },
  data() {
    return {
      isVideo,
      verifyAsset,
      shortText,
      getUniqueIndex,
      getAssetUrl,
      urlStateExpression,
      doc_ext: [".pdf", ".docx", ".xlsx", ".pptx", ".csv", ".txt", ".rtf"],
      files: [],
      steps: {},
      loading_service: false,
      file: null,
      assets_types: [],
      update_avatar: false,
      casting_call_uuid: '',
      casting_call: {},
      update_button_save: false,
      tabs_options: 0,
      links: [],
      modal_confirmation: false,
      item_to_delete: null,
      delete_type: null
    }
  },
  props: {
    invalid_size_file: {
      type: Boolean,
      default: false,
    },
    cover: {
      type: File,
      default: null,
    },
    main_color: {
      type: String,
      default: '#8443a5',
    },
    prev_files: {
      type: Array,
      default: () => [],
    },
    blob_cover: {
      type: String,
      default: '',
    }
  },
  created() {
    this.getData();
  },
  computed: {
    has_slug() {
      return this.$route.params.slug
    }
  },
  methods: {
    isImage(name) {
      if (!name) return false;
      const extension = name.split('.').pop().toLowerCase();
      return ['jpeg', 'jpg', 'png', 'gif', 'webp', 'avif'].includes(extension);
    },
    errorLoad(file) {
      getImageUpdatedfile(file.uuid).then((response) => {
        const img_new = response.file_url;
        file.preview.preview = img_new;
      });
    },
    disabledButton() {
      let counter_link = 0;
      this.links.forEach((link) => {
        if (urlStateExpression(link.link)) counter_link += 1;
      })
      return (counter_link === this.links.length) && (!this.isAllTypesUsed()) && (!this.invalid_size_file) && (this.cover || this.blob_cover)
    },
    imgOrvid(filename) {
      if (filename.includes(this.doc_ext)) {
        return '';
      } else {
        return filename;
      }
    },
    txtExt(filename) {
      return this.doc_ext.find(ext => filename.includes(ext)) || "";
    },
    isAllTypesUsed() {
      let counter_asset_types = 0;
      this.files.forEach((f) => {
        if (f.asset_type) counter_asset_types += 1;
      })
      this.links.forEach((f) => {
        if (f.type_link) counter_asset_types += 1;
      })

      return counter_asset_types !== (this.files.length + this.links.length)
    },
    addAssetType(file, asset_type) {
      file['asset_type'] = asset_type;
      this.update_button_save = !this.update_button_save;
    },
    hasChangeFiles() {
      setTimeout(() => {
        if (this.file) {
          const url_blob = URL.createObjectURL(this.file);
          const unique_index = getUniqueIndex()
          this.file['id'] = unique_index;
          if (this.file.type.includes('image')) {
            this.file['preview'] = {preview: url_blob, name: this.file.name};
            this.files.push(this.file)
            this.file = null;
          } else if (this.file.type.includes('video')) {
            this.file['preview'] = {preview: 'is_video', name: this.file.name};
            this.files.push(this.file)
            const thumbnail = getThumbnails(url_blob, {
              quality: 0.6
            });
            thumbnail.then((value) => {
              const url_blob_thubnail = URL.createObjectURL(value[0].blob);
              this.files.map((f) => {
                if (f.id === unique_index) {
                  f.preview.preview = url_blob_thubnail
                  this.update_avatar = !this.update_avatar;
                  this.file = null;
                }
              });
            });
          } else {
            this.file['preview'] = {preview: this.file.name, name: this.file.name};
            this.files.push(this.file)
            this.file = null;
          }
        }
      }, 200)
    },
    getData() {
      if (this.has_slug) {
        this.casting_call = Object.assign({}, this.$route.params.casting_call_data)
        this.casting_call_uuid = this.casting_call.uuid;
        this.getFormatUploadedFiles();
        if (this.casting_call.links.length > 0) this.links = this.casting_call.links.slice();
      } else {
        this.steps = JSON.parse(localStorage.getItem('steps'));

        this.casting_call.files = this.prev_files.length > 0 ? this.prev_files : [];
        if (this.casting_call.files.length > 0) this.getFormatUploadedFiles();
        if (this.steps?.links) this.links = this.steps.links.slice();
      }
    },
    getFormatUploadedFiles() {
      console.log(this.casting_call, 'Archivos')
      this.casting_call.files.forEach((file) => {
        this.files.push({
          preview: {
            preview: file.asset_url ? file.asset_url : (utils.isUrl(file.preview) ? file.preview : utils.getAssetUrl(file.preview)),
            name: file.asset_url ? file.asset_url : file.uuid_name,
          },
          uuid: file.uuid_name ? file.uuid_name : file.uuid,
          asset_type: this.$t('creator.asset_type').find((asset) => asset.value === file.type_file),
        });
      });
    },
    includeFormatImage(file) {
      if (file.includes('.jpeg') ||
      file.includes('.png') ||
      file.includes('.jpg')) {
        return true
      } else return false
    },
    deleteFromList(file) {
      this.item_to_delete = file
      this.delete_type = 'file'
      this.modal_confirmation = true
    },

    deleteFromListLink(link) {
      this.item_to_delete = link
      this.delete_type = 'link'
      this.modal_confirmation = true
    },

    closeModalConfirmation() {
      this.modal_confirmation = false
      this.item_to_delete = null
      this.delete_type = null
    },

    confirmDelete() {
      const item = this.item_to_delete

      if (!item) return

      if (this.delete_type === 'file') {

        if (!item.uuid) {
          this.files = this.files.filter((f) => f.id !== item.id)
          return this.closeModalConfirmation()
        }

        return deleteFile(this.casting_call_uuid,
          {
            files_uuid: [item.uuid]
          }
        ).then(() => {
          this.files = this.files.filter(
            (f) => f.uuid !== item.uuid
          )

          this.closeModalConfirmation()
        })
      }
      if (this.delete_type === 'link') {

        if (!item.uuid) {
          this.links = this.links.filter((f) => f.id !== item.id)
          return this.closeModalConfirmation()
        }
        return deleteLink(this.casting_call_uuid,item.uuid
        ).then(() => {
          this.links = this.links.filter(
            (f) => f.uuid !== item.uuid
          )

          this.closeModalConfirmation()
        })
      }
    },
    saveCastingcall() {
      if (this.cover) {
        const data_cover = new FormData();
        data_cover.append('cover_image', this.cover);
        data_cover.append('main_color', this.main_color);

        updateCastingCall(this.casting_call.uuid, data_cover).then((response) => {
          this.casting_call.cover_url = response.cover_url;
          this.casting_call.main_color = response.main_color;
        })
      }
      const form_data = new FormData();
      const files_to_create = this.files.filter((file) => file.id);
      const files_to_update = this.files.filter((file) => file.uuid).map((f) => {
        return {
          uuid: f.uuid,
          type_file: f.asset_type.value,
        }
      });

      files_to_create.forEach((file) => {
        form_data.append('files', file);
        form_data.append('type_files', file.asset_type.value)
      });

      this.loading_service = true;
      this.saveLinks();
      attatchFiles(this.casting_call_uuid, form_data).then((response_create) => {
        if (files_to_create.length > 0) this.$emit('update_campaign', response_create);
        updateFiles(this.casting_call_uuid, {files: files_to_update}).then(() => {
          localStorage.removeItem('steps');
          this.$root.$emit('quit_navbar_white');
          this.$router.push({name: 'view_casting_call', params: {slug: this.$route.params.slug}})
          this.loading_service = false;
        });
      });
    },
    setSteps() {
      const links_to_create = this.links.filter((link) => link.id);
      this.steps['links'] = links_to_create;
      this.steps['main_color'] = this.main_color;
      // this.steps['cover_url'] = this.blob_cover ? this.blob_cover : this.casting_call.cover_url;
      localStorage.setItem('steps', JSON.stringify(this.steps));
    },
    saveTempFiles() {
      const form_data = new FormData();

      if (this.cover) {
        form_data.append('cover', this.cover);
        form_data.append('main_color', this.main_color);
      }
      
      const files_to_create = this.files.filter((file) => file.id);

      const files_to_update = this.files.filter((file) => file.uuid).map((f) => {
        return {
          uuid: f.uuid,
          type_file: f.asset_type.value,
        }
      });

      files_to_create.forEach((file) => {
        form_data.append('files', file);
        form_data.append('type_files', file.asset_type.value)
      });

      this.loading_service = true;

      if (files_to_update.length > 0) form_data.append('files_to_update', JSON.stringify(files_to_update));

      createTempFile(form_data).then((response) => {
        this.steps['cover_url'] = utils.isUrl(response.cover) ? response.cover : utils.getAssetUrl(response.cover);
        this.loading_service = false;
        this.setSteps();
        this.$router.push({ name: 'steps_casting_call', params: {step: 'preview-card'} });
      });
    },
    save() {
      if (!this.isAllTypesUsed()) {
        if (this.has_slug) {
          this.saveCastingcall();
        } else {
          this.saveTempFiles();
        }
      }
    },
    saveLinks() {
      const links_to_create = this.links.filter((link) => link.id);
      const links_to_update = this.links.filter((link) => link.uuid);
      attatchLinks(this.casting_call_uuid, {links: links_to_create}).then(() => {
        updateLinks(this.casting_call_uuid, {links: links_to_update}).then(() => {
        
        });
      });
    },
  },
}
</script>
<style scoped lang="scss">
.button-tabs-options {
  background: #e9ecef !important;
  border-radius: 0.7em !important;
  padding: 1.5em !important;

  &:hover  {
    background: #dee2e6 !important;

    &:disabled {
      background: #e9ecef !important;
    }
  }

  &.active {
    background-color: #54575a !important;
    color: white !important
  }
}
.spinner-waiting-service {
  width: 18px;
  height: 18px;
}
.mr-05 {
  margin-right: 0.5em;
}
.avatar-preview-sample {
  width: 45px;
  height: 45px;
  object-fit: cover;
  border-radius: 1em !important;
  margin: 0 1em 0 0;
}
</style>